import VideoGrid from "./VideoGrid";
import MainVideo from "./MainVideo";
import { useIsGroupCall } from "../../../hooks/useIsGroupCall";

export default function VideoListComponent() {
  const isGroupCall = useIsGroupCall();

  return (
    <div className="flex min-h-0 w-full flex-col gap-4 sm:gap-5">
      {isGroupCall ? (
        <>
          <div className="h-[22%] min-h-0 shrink-0">
            <VideoGrid />
          </div>
          <MainVideo compactTopStrip />
        </>
      ) : (
        <MainVideo compactTopStrip={false} />
      )}
    </div>
  );
}
